import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .carl-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    .drivers {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      gap: var(--between-row-padding-lg);
    }

    .driver-image {
      display: flex;
      background-color: #f8f8f8;
    }

    .driver-info {
      background-color: #f8f8f8;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: calc(40rem / var(--default-rem-px-count))
        calc(20rem / var(--default-rem-px-count));
    }

    h2 {
      margin-bottom: calc(20rem / var(--default-rem-px-count));
    }

    /* Eyebrow pins the body-small scale; the tag is a p, so the body
       default would otherwise apply. */
    .eyebrow {
      color: #315470;
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
      margin-bottom: calc(10rem / var(--default-rem-px-count));
    }

    .description {
      margin-bottom: calc(20rem / var(--default-rem-px-count));
    }

    img {
      width: 100%;
      margin: auto 0;
    }

    @media (min-width: 600px) {
      .drivers {
        grid-column: 2 / 14;
      }

      .driver-info {
        padding: calc(50rem / var(--default-rem-px-count))
          calc(30rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      .drivers {
        grid-column: 3 / 13;
        /* Production spacing between alternating rows; wider than the
           shared -lg var on purpose. */
        gap: calc(80rem / var(--default-rem-px-count));
      }

      /* 60/40 image/card split, flush per the mock (no gutter between
         image and card); even rows flip the two columns. */
      .driver-wrapper {
        display: grid;
        grid-template-columns: 6fr 4fr;
      }

      .driver-wrapper:nth-child(even) {
        grid-template-columns: 4fr 6fr;
      }

      .driver-wrapper:nth-child(even) .driver-image {
        grid-column: 2;
        grid-row: 1;
      }

      .driver-wrapper:nth-child(even) .driver-info {
        grid-column: 1;
        grid-row: 1;
      }

      .driver-info {
        padding: calc(50rem / var(--default-rem-px-count));
      }

      .description {
        margin-bottom: calc(30rem / var(--default-rem-px-count));
      }
    }
  `,
];
